import { Role } from "common/types/user.type"

const roles = Object.values(Role).filter(value => typeof value === "string")

roles.sort((roleA, roleB) => {
  return Role[roleB] - Role[roleA]
})

export { roles }
